import { useNavigate, useParams } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import { Mic as MicIcon } from '@mui/icons-material';
import NoteProcessingProgress from '../components/NoteProcessing/NoteProcessingProgress';
import UpcomingEncountersCard from '@components/ui/cards/UpcomingEncountersCard';
import BaseBlock from '../components/Patient/Blocks/BaseBlock';
import { useUser } from '@features/user';
import { useEffect } from 'react';

export type NoteStatusType = {
  note_id: string;
  job_status: 'completed' | 'processing' | 'errored';
  note_title: string;
  time_uploaded: number;
  processing_tasks: {
    name: string;
    status: string;
    progress?: number;
  }[];
  errors: {
    error: string;
  }[];
  error_message: string;
};

export const NoteProcessingView = () => {
  const { noteId } = useParams();
  const navigate = useNavigate();
  const { userState } = useUser();

  const hasEhrMode = userState?.featureFlags?.ehr_mode;

  return (
    <div className="flex flex-col items-center min-h-full p-4">
      <Box
        sx={{
          width: '100%',
          maxWidth: 600,
          minWidth: 0,
          overflowWrap: 'anywhere',
          mx: 'auto',
          mt: 4,
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
          alignItems: 'center',
        }}
      >
        {/* Main processing card */}
        <NoteProcessingProgress
          noteId={noteId || ''}
          onComplete={noteId => navigate(`/note/${noteId}`)}
        />

        {/* Informative text */}
        <Typography variant="body1" color="text.secondary" align="center" sx={{ px: 2 }}>
          Your note will be available in a few moments. You can wait here or move on to your next
          appointment. This note will be available in your notes tab.
        </Typography>

        {/* Show different content based on ehr_mode */}
        {hasEhrMode ? (
          <BaseBlock sx={{ width: '100%', p: 0 }}>
            <UpcomingEncountersCard />
          </BaseBlock>
        ) : (
          <Button
            variant="contained"
            color="primary"
            startIcon={<MicIcon />}
            onClick={() => navigate('/encounters/active')}
            size="large"
          >
            Record next appointment
          </Button>
        )}
      </Box>
    </div>
  );
};
